import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const DriveWrapper = styled(Flex)`
  padding: 15px 15px;
  margin: 15px 0;
  width: 100%;
  height: 90px;
  background: ${props => (props?.disableDiv ? COLORS.DISABLED : COLORS.WHITE)};
  border: 1px solid ${COLORS.BLUE_P_92};
  border-radius: 10px;
  path {
    transition: 0.5s;
  }
  :hover {
    translate: 1.01;
    path {
      fill: ${COLORS.PRIMARY};
    }
  }
  pointer-events: ${props => (props?.disableDiv ? 'none' : 'auto')};
`

export const DriveInfoFlex = styled(Flex)`
  gap: 1px;
  margin-left: 10px;
`
export const DriveNameDiv = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const DriveInfoDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
`
export const DriveModeDive = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
`
export const ChangeDriveDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  cursor: pointer;
`
export const DriveWrap = styled(Flex)`
  padding: 15px 15px;
  margin: 15px 0;
  width: 100%;
  height: 90px;
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.BLUE_P_92};
  border-radius: 10px;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`
export const SelectDiv = styled.div`
  margin: 20px 0;
`
export const AddHostDiv = styled.div`
  padding: 0;
`
export const FooterFlex = styled(Flex)`
  gap: 10px;
`
export const ShortListDiv = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
  padding-bottom: 5px;
`
export const ShortListCanDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const ToggleDiv = styled.div`
  padding: 10px 0;
`
export const CollageDetailsFlex = styled(Flex)`
  margin: 0 0 20px 0;
  padding: 20px 15px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  line-height: normal;
`
export const AddClgDiv = styled.div`
  margin: ${props => (props?.margin ? props?.margin : '28px 0')};
  position: relative;
`
export const ShortlistFlex = styled(Flex)`
  width: 100%;
  padding: 10px;
  height: 44px;
  background: ${props => (props?.background ? props?.background : '#eff8f4')};
  border-radius: 10px;
  gap: 10px;
`
export const ShortlistDiv = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const EventDiv = styled.div`
  cursor: ${props => (props?.disableDiv ? 'not-allowed' : 'pointer')};
`
export const RatingFlex = styled(Flex)`
  gap: 5px;
`
export const FormTextLablel = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
`
